module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "50px"
    },
    attrs: {
      "id": "acknowledgements"
    }
  }, [_vm._v("Acknowledgements")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("All of the novels in the St-Cyr–Kohler series incorporate a few words and brief passages in French or German. Dr. Dennis Essar of Brock University very kindly helped with the French, as did the artist Pierrette Laroche, while Professor Schutz, of Germanic and Slavic Studies at Brock, helped with the German. A very special thanks must also be extended to Robin Walz for his marvellous "), _c('i', [_vm._v("Pulp Surrealism")]), _vm._v(", to Sarah Fishman for her excellent "), _c('i', [_vm._v("The Battle for Children: World War II, Youth Crime, and Juvenile Justice in Twentieth-Century France")]), _vm._v(" and "), _c('i', [_vm._v("We Will Wait—Wives of French Prisoners of War, 1940–1945,")]), _vm._v(" and to photographer Alex Waterhouse-Hayward of Vancouver for his very kind assistance with all things Argentine. Should there be any errors­, they are my own and for these I apologize.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64e09607","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/6-acknowledgements.vue
// module id = 75
// module chunks = 0